import axios from 'axios'

export function fetchActivePaymentMethods() {
    return axios.get('/api/company/payment-methods/active')
        .then((res) => {
            if (res.data.status === 'success') {
                return res.data.payment_methods
            }

            return []
        })
        .catch(() => [])
}

export function fetchActivePaymentMethodsForSelect() {
    return fetchActivePaymentMethods().then((methods) => {
        return methods.map((method) => ({
            value: method.id,
            text: method.name,
        }))
    })
}

export function paymentMethodsToFilterOptions(methods) {
    return methods.map((method) => ({
        id: method.id,
        label: method.name,
    }))
}
